import { createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import { useAuthStore } from '../stores/auth'
import { useNavBarStore } from '../stores/nav-bar'
const whiteList = ['/auth/login', '/auth-redirect']

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/dashboard/index.vue'),
      },
      {
        name: 'cars',
        path: 'cars',
        component: () => import('../pages/cars/CarsPage.vue'),
      },
      {
        name: 'allocation',
        path: '/allocation',
        children: [
          {
            name: 'all-allocations',
            path: '',
            component: () => import('../pages/allocation-new/all-allocation/index.vue'),
          },
          {
            name: 'create-allocation',
            path: 'create',
            component: () => import('../pages/allocation-new/create-new-car/index.vue'),
          },
          {
            name: 'detail-allocation',
            path: ':id',
            component: () => import('../pages/allocation-new/detail-allocation/index.vue'),
          },
        ],
      },
      {
        name: 'new-car',
        path: '/new-car',
        children: [
          {
            path: '/sales-plan',
            meta: {
              roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin', 'accountant'],
            },
            children: [
              {
                path: '',
                name: 'sales-plan',
                component: () => import('../pages/sales-plan/all-sales-plan/index.vue'),
              },
              {
                path: ':id',
                name: 'detail-sales-plan',
                component: () => import('../pages/sales-plan/detail-sales-plan/index.vue'),
              },
            ],
          },
          {
            path: '/sales-quarter',
            meta: {
              roles: ['super_admin', 'director', 'purchasing_supervisor', 'new_car_supervisor', 'accountant'],
            },
            children: [
              {
                path: '',
                name: 'sales-quarter',
                component: () => import('../pages/sales-plan/all-sales-quarter/index.vue'),
              },
              {
                path: ':id',
                name: 'detail-sales-quarter',
                component: () => import('../pages/sales-plan/detail-sales-quarter/index.vue'),
              },
            ],
          },
          {
            path: '/complaint',
            children: [
              {
                path: '',
                name: 'complaint',
                component: () => import('../pages/complaint/all-complaint/index.vue'),
              },
              {
                path: 'complaint/create',
                name: 'create-complaint',
                component: () => import('../pages/complaint/create-complaint/index.vue'),
              },
              {
                path: 'complaint/:id',
                name: 'detail-complaint',
                component: () => import('../pages/complaint/detail-complaint/index.vue'),
              },
            ],
          },
          {
            path: '/selling-major',
            name: 'selling-major',
            meta: {
              roles: [
                'super_admin',
                'director',
                'bank_admin',
                'accountant',
                'new_car_supervisor',
                'new_car_admin',
                'new_car_sales_employee',
              ],
            },
            children: [
              {
                path: '/sales-target',
                meta: {
                  roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin', 'new_car_sales_employee'],
                },
                children: [
                  {
                    path: '',
                    name: 'sales-target',
                    component: () => import('../pages/sales-target/all-sales-target/index.vue'),
                  },
                ],
              },
              {
                path: '/sales-kpi-month',
                meta: {
                  roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin', 'new_car_sales_employee'],
                },
                children: [
                  {
                    path: '',
                    name: 'sales-kpi-month',
                    component: () => import('../pages/sales-plan/all-sales-kpi-month/index.vue'),
                  },
                  {
                    path: '/sales-kpi-month/:id',
                    name: 'detail-sales-kpi-month',
                    component: () => import('../pages/sales-plan/detail-sales-kpi-month/index.vue'),
                  },
                ],
              },
              {
                path: '/customer',
                meta: {
                  roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin'],
                },
                children: [
                  {
                    path: '',
                    name: 'customer',
                    component: () => import('../pages/customer/all-customer/index.vue'),
                  },
                  {
                    path: '/customer/:department/:id',
                    name: 'detail-customer',
                    component: () => import('../pages/customer/detail-customer/index.vue'),
                  },
                ],
              },
              {
                path: '/sell-request',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'sell-request',
                    component: () => import('../pages/sell-request/all-sell-request/index.vue'),
                  },
                  {
                    path: '/sell-request/:department/create',
                    name: 'create-sell-request',
                    component: () => import('../pages/sell-request/create-sell-request/index.vue'),
                  },
                  {
                    path: '/sell-request/:department/change/:id',
                    name: 'detail-change-sell-request',
                    component: () => import('../pages/sell-request/detail-change-sell-request/index.vue'),
                  },
                  {
                    path: '/sell-request/:department/:id',
                    name: 'detail-sell-request',
                    component: () => import('../pages/sell-request/detail-sell-request/index.vue'),
                  },
                ],
              },
              {
                path: '/sales-form',
                name: 'sales-form',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '/sell-form/new_car/lump_sum',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'sell-form-lump-sum',
                        component: () => import('../pages/sales-form/sell-form/all-sell-form/index.vue'),
                      },
                      {
                        path: '/sell-form/:department/:type/create',
                        name: 'create-sell-form-lump-sum',
                        component: () => import('../pages/sales-form/sell-form/create-sell-form/index.vue'),
                      },
                      {
                        path: '/sell-form/:department/:type/:id',
                        name: 'detail-sell-form-lump-sum',
                        component: () => import('../pages/sales-form/sell-form/detail-sell-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/sell-form/new_car/installment',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'sell-form-installment',
                        component: () => import('../pages/sales-form/sell-form/all-sell-form/index.vue'),
                      },
                      {
                        path: '/sell-form/:department/:type/create',
                        name: 'create-sell-form-installment',
                        component: () => import('../pages/sales-form/sell-form/create-sell-form/index.vue'),
                      },
                      {
                        path: '/sell-form/:department/:type/:id',
                        name: 'detail-sell-form-installment',
                        component: () => import('../pages/sales-form/sell-form/detail-sell-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/receipt-form/new_car',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'receipt-form',
                        component: () => import('../pages/sales-form/receipt-form/all-receipt-form/index.vue'),
                      },
                      {
                        path: '/receipt-form/:department/create',
                        name: 'create-receipt-form',
                        component: () => import('../pages/sales-form/receipt-form/create-receipt-form/index.vue'),
                      },
                      {
                        path: '/receipt-form/:department/:id',
                        name: 'detail-receipt-form',
                        component: () => import('../pages/sales-form/receipt-form/detail-receipt-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/agreement-form/new_car',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'agreement-form',
                        component: () => import('../pages/sales-form/agreement-form/all-agreement-form/index.vue'),
                      },
                      {
                        path: '/agreement-form/:department/create',
                        name: 'create-agreement-form',
                        component: () => import('../pages/sales-form/agreement-form/create-agreement-form/index.vue'),
                      },
                      {
                        path: '/agreement-form/:department/:id',
                        name: 'detail-agreement-form',
                        component: () => import('../pages/sales-form/agreement-form/detail-agreement-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/handover-form/new_car',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'handover-form',
                        component: () => import('../pages/sales-form/handover-form/all-handover-form/index.vue'),
                      },
                      {
                        path: '/handover-form/:department/create',
                        name: 'create-handover-form',
                        component: () => import('../pages/sales-form/handover-form/create-handover-form/index.vue'),
                      },
                      {
                        path: '/handover-form/:department/:id',
                        name: 'detail-handover-form',
                        component: () => import('../pages/sales-form/handover-form/detail-handover-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/checking-form/new_car',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'checking-form',
                        component: () => import('../pages/sales-form/checking-form/all-checking-form/index.vue'),
                      },
                      {
                        path: '/checking-form/:department/create',
                        name: 'create-checking-form',
                        component: () => import('../pages/sales-form/checking-form/create-checking-form/index.vue'),
                      },
                      {
                        path: '/checking-form/:department/:id',
                        name: 'detail-checking-form',
                        component: () => import('../pages/sales-form/checking-form/detail-checking-form/index.vue'),
                      },
                    ],
                  },
                  {
                    path: '/settlement-form/new_car',
                    meta: {
                      roles: [
                        'super_admin',
                        'director',
                        'new_car_supervisor',
                        'new_car_admin',
                        'new_car_sales_employee',
                        'accountant',
                      ],
                    },
                    children: [
                      {
                        path: '',
                        name: 'settlement-form',
                        component: () => import('../pages/sales-form/settlement-form/all-settlement-form/index.vue'),
                      },
                      {
                        path: '/settlement-form/:department/create',
                        name: 'create-settlement-form',
                        component: () => import('../pages/sales-form/settlement-form/create-settlement-form/index.vue'),
                      },
                      {
                        path: '/settlement-form/:department/:id',
                        name: 'detail-settlement-form',
                        component: () => import('../pages/sales-form/settlement-form/detail-settlement-form/index.vue'),
                      },
                    ],
                  },
                ],
              },
              {
                path: '/repair-suggestion/new_car',
                meta: {
                  roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin', 'new_car_sales_employee'],
                },
                children: [
                  {
                    path: '',
                    name: 'repair-suggestion',
                    component: () => import('../pages/repair-suggestion/all-repair-suggestion/index.vue'),
                  },
                  {
                    path: '/repair-suggestion/:department/create',
                    name: 'create-repair-suggestion',
                    component: () => import('../pages/repair-suggestion/create-repair-suggestion/index.vue'),
                  },
                  {
                    path: '/repair-suggestion/:department/:id',
                    name: 'detail-repair-suggestion',
                    component: () => import('../pages/repair-suggestion/detail-repair-suggestion/index.vue'),
                  },
                ],
              },
              {
                path: '/sell-progress/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'bank_admin',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'sell-progress',
                    component: () => import('../pages/sell-progress/all-sell-progress/index.vue'),
                  },
                  {
                    path: '/sell-progress/:department/:id',
                    name: 'detail-sell-progress',
                    component: () => import('../pages/sell-progress/detail-sell-progress/index.vue'),
                  },
                ],
              },
              {
                path: '/retrieval-request/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'retrieval-request',
                    component: () => import('../pages/retrieval-request/all-retrieval-request/index.vue'),
                  },
                  {
                    path: '/retrieval-request/:department/create',
                    name: 'create-retrieval-request',
                    component: () => import('../pages/retrieval-request/create-retrieval-request/index.vue'),
                  },
                  {
                    path: '/retrieval-request/:department/:id',
                    name: 'detail-retrieval-request',
                    component: () => import('../pages/retrieval-request/detail-retrieval-request/index.vue'),
                  },
                ],
              },
              // {
              //   path: '/bank-request/new_car',
              //   meta: {
              //     roles: [
              //       'super_admin',
              //       'director',
              //       'new_car_supervisor',
              //       'new_car_admin',
              //       'bank_admin',
              //       'new_car_sales_employee',
              //       'accountant',
              //     ],
              //   },
              //   children: [
              //     {
              //       path: '',
              //       name: 'bank-request',
              //       component: () => import('../pages/bank-request/all-bank-request/index.vue'),
              //     },
              //     {
              //       path: '/bank-request/:department/create',
              //       name: 'create-bank-request',
              //       component: () => import('../pages/bank-request/create-bank-request/index.vue'),
              //     },
              //     {
              //       path: '/bank-request/:department/:id',
              //       name: 'detail-bank-request',
              //       component: () => import('../pages/bank-request/detail-bank-request/index.vue'),
              //     },
              //   ],
              // },
              {
                path: '/invoice-request/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'invoice-request',
                    component: () => import('../pages/invoice-request/all-invoice-request/index.vue'),
                  },
                  {
                    path: '/invoice-request/:department/create',
                    name: 'create-invoice-request',
                    component: () => import('../pages/invoice-request/create-invoice-request/index.vue'),
                  },
                  {
                    path: '/invoice-request/:department/:id',
                    name: 'detail-invoice-request',
                    component: () => import('../pages/invoice-request/detail-invoice-request/index.vue'),
                  },
                ],
              },
              {
                path: '/insurance-request/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'bank_admin',
                    'new_car_sales_employee',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'insurance-request',
                    component: () => import('../pages/insurance-request/all-insurance-request/index.vue'),
                  },
                  {
                    path: '/insurance-request/:department/create',
                    name: 'create-insurance-request',
                    component: () => import('../pages/insurance-request/create-insurance-request/index.vue'),
                  },
                  {
                    path: '/insurance-request/:department/:id',
                    name: 'detail-insurance-request',
                    component: () => import('../pages/insurance-request/detail-insurance-request/index.vue'),
                  },
                ],
              },
              {
                path: '/sell-contract/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'sell-contract',
                    component: () => import('../pages/sell-contract/all-sell-contract/index.vue'),
                  },
                  {
                    path: '/sell-contract/:department/create',
                    name: 'create-sell-contract',
                    component: () => import('../pages/sell-contract/create-sell-contract/index.vue'),
                  },
                  {
                    path: '/sell-contract/:department/:id',
                    name: 'detail-sell-contract',
                    component: () => import('../pages/sell-contract/detail-sell-contract/index.vue'),
                  },
                ],
              },
              {
                path: '/handover-request/new_car',
                meta: {
                  roles: ['super_admin', 'director', 'new_car_supervisor', 'new_car_admin', 'new_car_sales_employee'],
                },
                children: [
                  {
                    path: '',
                    name: 'handover-request',
                    component: () => import('../pages/handover-request/all-handover-request/index.vue'),
                  },
                  {
                    path: '/handover-request/:department/:id',
                    name: 'detail-handover-request',
                    component: () => import('../pages/handover-request/detail-handover-request/index.vue'),
                  },
                ],
              },
              {
                path: '/liquidation/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'liquidation',
                    component: () => import('../pages/liquidation/all-liquidation/index.vue'),
                  },
                  {
                    path: '/liquidation/:department/create',
                    name: 'create-liquidation',
                    component: () => import('../pages/liquidation/create-liquidation/index.vue'),
                  },
                  {
                    path: '/liquidation/:department/:id',
                    name: 'detail-liquidation',
                    component: () => import('../pages/liquidation/detail-liquidation/index.vue'),
                  },
                ],
              },
              {
                path: '/accessory-form/new_car',
                meta: {
                  roles: [
                    'super_admin',
                    'director',
                    'new_car_supervisor',
                    'new_car_admin',
                    'new_car_sales_employee',
                    'accountant',
                  ],
                },
                children: [
                  {
                    path: '',
                    name: 'accessory-form',
                    component: () => import('../pages/form/accessory-form/all-accessory-form/index.vue'),
                  },
                  {
                    path: '/accessory-form/:department/create',
                    name: 'create-accessory-form',
                    component: () => import('../pages/form/accessory-form/create-accessory-form/index.vue'),
                  },
                  {
                    path: '/accessory-form/:department/:id',
                    name: 'detail-accessory-form',
                    component: () => import('../pages/form/accessory-form/detail-accessory-form/index.vue'),
                  },
                ],
              },
            ],
          },
          // {
          //   path: "/admin",
          //   name: "Admin",
          //   meta: {
          //     title: "admin",
          //     icon: "fa fa-address-card-o",
          //     roles: [
          //       "super_admin",
          //       "director",
          //       "new_car_supervisor",
          //       "new_car_admin",
          //       "accountant",
          //       "bank_admin"
          //     ]
          //   },
          //   children: [
          //     {
          //       path: "/sales-admin/new_car",
          //       meta: {
          //         roles: [
          //           "super_admin",
          //           "director",
          //           "new_car_supervisor",
          //           "new_car_admin"
          //         ]
          //       },
          //       children: [
          //         {
          //           path: "",
          //           name: "SalesAdminForNewCar",
          //           component: () =>
          //             import("../pages/sell-request/sales-admin/index.vue"),
          //           meta: {
          //             title: "salesAdmin",
          //             activeMenu: "/sales-admin/new_car"
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       path: "/incurred-form/new_car",
          //       meta: {
          //         roles: [
          //           "super_admin",
          //           "director",
          //           "new_car_supervisor",
          //           "new_car_admin",
          //           "accountant"
          //         ]
          //       },
          //       children: [
          //         {
          //           path: "",
          //           name: "IncurredForm",
          //           component: () =>
          //             import("../pages/incurred-form/all-incurred-form/index.vue"),
          //           meta: {
          //             title: "incurredForm",
          //             activeMenu: "/incurred-form/new_car"
          //           }
          //         },
          //         {
          //           path: "/incurred-form/:department/create",
          //           name: "CreateIncurredFormForNewCar",
          //           component: () =>
          //             import("../pages/incurred-form/create-incurred-form/index.vue"),
          //           meta: {
          //             title: "createIncurredForm",
          //             activeMenu: "/incurred-form/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/incurred-form/:department/:id",
          //           name: "DetailIncurredFormForNewCar",
          //           component: () =>
          //             import("../pages/incurred-form/detail-incurred-form/index.vue"),
          //           meta: {
          //             title: "detailIncurredForm",
          //             activeMenu: "/incurred-form/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     }
          //   ]
          // },
          // {
          //   path: "/form/new_car",
          //   meta: {
          //     title: "form",
          //     icon: "fa fa-wpforms",
          //     roles: [
          //       "super_admin",
          //       "new_car_supervisor",
          //       "new_car_admin",
          //       "bank_admin",
          //       "new_car_sales_employee"
          //     ]
          //   },
          //   children: [
          //     {
          //       path: "/payment-request/new_car",
          //       children: [
          //         {
          //           path: "",
          //           name: "PaymentRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/payment-request/all-payment-request/index.vue"),
          //           meta: {
          //             title: "paymentRequest",
          //             activeMenu: "/payment-request/new_car",
          //             hasNoti: true,
          //             notiValue: () => PaymentRequestsModule.count
          //           }
          //         },
          //         {
          //           path: "/payment-request/:department/create",
          //           name: "CreatePaymentRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/payment-request/create-payment-request/index.vue"),
          //           meta: {
          //             title: "createPaymentRequest",
          //             activeMenu: "/payment-request/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/payment-request/:department/:id",
          //           name: "DetailPaymentRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/payment-request/detail-payment-request/index.vue"),
          //           meta: {
          //             title: "detailPaymentRequest",
          //             activeMenu: "/payment-request/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       path: "/advance-request/new_car",
          //       children: [
          //         {
          //           path: "",
          //           name: "AdvanceRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/advance-request/all-advance-request/index.vue"),
          //           meta: {
          //             title: "advanceRequest",
          //             activeMenu: "/advance-request/new_car",
          //             hasNoti: true,
          //             notiValue: () => AdvanceRequestsModule.count
          //           }
          //         },
          //         {
          //           path: "/advance-request/:department/create",
          //           name: "CreateAdvanceRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/advance-request/create-advance-request/index.vue"),
          //           meta: {
          //             title: "createAdvanceRequest",
          //             activeMenu: "/advance-request/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/advance-request/:department/:id",
          //           name: "DetailAdvanceRequestForNewCar",
          //           component: () =>
          //             import("../pages/form/advance-request/detail-advance-request/index.vue"),
          //           meta: {
          //             title: "detailAdvanceRequest",
          //             activeMenu: "/advance-request/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       path: "/accessary-form/new_car",
          //       children: [
          //         {
          //           path: "",
          //           name: "AccessaryFormForNewCar",
          //           component: () =>
          //             import("../pages/form/accessary-form/all-accessary-form/index.vue"),
          //           meta: {
          //             title: "accessaryFormManually",
          //             activeMenu: "/accessary-form/new_car",
          //             hasNoti: true,
          //             notiValue: () => AccessaryFormsModule.count
          //           }
          //         },
          //         {
          //           path: "/accessary-form/:department/create",
          //           name: "CreateAccessaryFormForNewCar",
          //           component: () =>
          //             import("../pages/form/accessary-form/create-accessary-form/index.vue"),
          //           meta: {
          //             title: "createAccessaryFormManually",
          //             activeMenu: "/accessary-form/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/accessary-form/:department/:id",
          //           name: "DetailAccessaryFormForNewCar",
          //           component: () =>
          //             import("../pages/form/accessary-form/detail-accessary-form/index.vue"),
          //           meta: {
          //             title: "detailAccessaryFormManually",
          //             activeMenu: "/accessary-form/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       path: "/fuel-form/new_car",
          //       children: [
          //         {
          //           path: "",
          //           name: "FuelFormForNewCar",
          //           component: () =>
          //             import("../pages/form/fuel-form/all-fuel-form/index.vue"),
          //           meta: {
          //             title: "fuelForm",
          //             activeMenu: "/fuel-form/new_car",
          //             hasNoti: true,
          //             notiValue: () => FuelFormsModule.count
          //           }
          //         },
          //         {
          //           path: "/fuel-form/:department/create",
          //           name: "CreateFuelFormForNewCar",
          //           component: () =>
          //             import("../pages/form/fuel-form/create-fuel-form/index.vue"),
          //           meta: {
          //             title: "createFuelForm",
          //             activeMenu: "/fuel-form/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/fuel-form/:department/:id",
          //           name: "DetailFuelFormForNewCar",
          //           component: () =>
          //             import("../pages/form/fuel-form/detail-fuel-form/index.vue"),
          //           meta: {
          //             title: "detailFuelForm",
          //             activeMenu: "/fuel-form/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       path: "/washing-form/new_car",
          //       children: [
          //         {
          //           path: "",
          //           name: "WashingFormForNewCar",
          //           component: () =>
          //             import("../pages/form/washing-form/all-washing-form/index.vue"),
          //           meta: {
          //             title: "washingForm",
          //             activeMenu: "/washing-form/new_car",
          //             hasNoti: true,
          //             notiValue: () => WashingFormsModule.count
          //           }
          //         },
          //         {
          //           path: "/washing-form/:department/create",
          //           name: "CreateWashingFormForNewCar",
          //           component: () =>
          //             import("../pages/form/washing-form/create-washing-form/index.vue"),
          //           meta: {
          //             title: "createWashingForm",
          //             activeMenu: "/washing-form/new_car",
          //             hidden: true
          //           }
          //         },
          //         {
          //           path: "/washing-form/:department/:id",
          //           name: "DetailWashingFormForNewCar",
          //           component: () =>
          //             import("../pages/form/washing-form/detail-washing-form/index.vue"),
          //           meta: {
          //             title: "detailWashingForm",
          //             activeMenu: "/washing-form/new_car",
          //             hidden: true
          //           }
          //         }
          //       ]
          //     }
          //   ]
          // }
        ],
      },

      {
        path: '/category',
        name: 'category',
        component: () => import('../pages/category/all-category/index.vue'),
      },
      {
        path: '/staff',
        meta: {
          roles: ['super_admin', 'director', 'purchasing_supervisor'],
        },
        children: [
          {
            path: '',
            name: 'staff',
            component: () => import('../pages/staff/all-staff/index.vue'),
          },
          {
            path: ':id',
            name: 'detail-staff',
            component: () => import('../pages/staff/detail-staff/index.vue'),
          },
        ],
      },
      {
        path: '/new-car-staff',
        name: 'new-car-staff',
        meta: {
          roles: ['super_admin', 'director', 'new_car_supervisor', 'purchasing_supervisor'],
        },
        component: () => import('../pages/staff/all-new-car-staff/index.vue'),
      },
      // {
      //   path: '/meta',
      //   component: NestedLayout,
      //   meta: {
      //     roles: ['super_admin'],
      //   },
      //   children: [
      //     {
      //       path: '',
      //       name: 'Meta',
      //       component: () => import('../pages/meta/all-meta/index.vue'),
      //       meta: {
      //         title: 'meta',
      //         activeMenu: '/meta',
      //       },
      //     },
      //   ],
      // },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  const navBarStore = useNavBarStore()
  const authStore = useAuthStore()
  navBarStore.setTabDefs({ tabs: [] })
  navBarStore.setActionDefs([])

  // CHECK PERMISSION
  // Determine whether the user has logged in
  if (authStore.token) {
    if (to.path === '/auth/login') {
      // If is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      // Check whether the user has obtained his permission roles
      if (authStore.roles.length === 0) {
        try {
          // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
          await authStore.checkToken()
          // Generate accessible routes map based on role
          // PermissionModule.GenerateRoutes(MeModule.roles)
          // Dynamically add accessible routes
          // router.addRoutes(PermissionModule.dynamicRoutes)
          // Hack: ensure addRoutes is complete
          // Set the replace: true, so the navigation will not leave a history record
          console.log('to', to)
          next({ ...to, replace: true })
        } catch (err) {
          // Remove token and redirect to login page
          authStore.resetToken()
          // Message({
          //   type: 'error',
          //   message: err.message,
          // })
          next(`/login?redirect=${to.path}`)
        }
      } else {
        // PermissionModule.GenerateRoutes(MeModule.roles)
        next()
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/auth/login?redirect=${to.path}`)
    }
  }
})

export default router
